import { IApplicationState } from 'setup/store'

export const selectCurrenciesList = (state: IApplicationState) => state.settings.data.currencies
export const selectSettings = (state: IApplicationState) => state.settings.data
